module.exports = __webpack_public_path__ + "static/newui-4d2690a71bccb07e0dbf3d0ed2b8e5bc.png";